<template>
  <ReportLayoutBase :has-title="false">
    <div class="report-layout__selectors">
      <a :href="funnelLink" class="report-layout__link" data-cy="back-to-funnel-page-button">
        <UgIcon class="report-layout__link-icon" icon="arrow-left" width="16" height="16" />
        <span>{{ t("backToFunnelAnalysis") }}</span>
      </a>
    </div>
    <RouterView />
  </ReportLayoutBase>
</template>

<script setup lang="ts">
import { UgIcon } from "@bebit/atomic";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import ReportLayoutBase from "./_ReportLayoutBase.vue";

const { t } = useI18n();

const route = useRoute();

const funnelLink = computed(() => `/funnel/${route.query.funnelId}` as string);
</script>

<style lang="scss" scoped>
.report-layout__selectors {
  display: flex;
  height: 64px;
  width: auto;
  align-items: center;
  padding: 0 20px;
}
.report-layout__link {
  align-items: center;
  display: inline-flex;
  line-height: 1;
  cursor: pointer;
  color: $colorBase700;
}
.report-layout__link-icon {
  margin-right: 6px;
  :deep(path) {
    fill: $colorBase700;
  }
}
</style>

<i18n lang="yaml">
en:
  backToFunnelAnalysis: Back to funnel analysis
ja:
  backToFunnelAnalysis: 行動ファネル分析に戻る
zh-hant:
  backToFunnelAnalysis: 返回行為程序分析
zh-hans:
  backToFunnelAnalysis: 返回行为程序分析
</i18n>
